<template>
  <div :class="$style.header">
    <div :class="$style.shim"></div>
    <div :class="$style.main">
      <a :class="$style.logoWrapper" :href="geekbangServer">
        <img :class="$style.logo" :src="logo">
      </a>
      <div :class="$style.userInfo">
        <template v-if="loginUser">
          <div :class="$style.menuIcon" @click="goAccount">
            <i class="iconfont icon-wode"></i>
          </div>
        </template>
        <template v-else>
          <div :class="$style.login" @click="login">登录</div>
        </template>
        <div :class="$style.menuIcon" @click="isShowModal = !isShowModal">
          <template v-if="!isShowModal">
            <i class="iconfont icon-caidan"></i>
          </template>
          <template v-else>
            <i class="iconfont icon-guanbi"></i>
          </template>
        </div>
      </div>
    </div>

    <div :class="$style.dropModal" v-show="isShowModal">
      <div :class="$style.mask"></div>
      <div :class="$style.modalContent">
        <div :class="$style.menuList">
          <div
            :class="$style.menuItemWrapper"
            :key="gIndex"
            v-for="(group, gIndex) in menuList">
            <div :class="$style.menuItem" @click="jump(group, gIndex)">
              <span>{{ group.name }}</span>
              <i class="iconfont icon-arrow" :class="[$style.arrowIcon, {[$style.open]: group.isActive }]" v-if="group.submenu"></i>
            </div>
            <!-- 子菜单 -->
            <div :class="$style.submenuListWrapper" ref="submenuListWrapper">
              <div :class="$style.submenuList" ref="submenuList">
                <div
                  :class="[$style.submenuItem, {[$style.disabled]: item.disabled}]"
                  :key="index"
                  v-for="(item, index) in group.submenu"
                  @click.stop="jump(item, index)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { login } from '@geekbang/time.sdk'

import logo from '@/assets/img/logo/logo-h5.png'
import menuImg from '@/assets/img/home/menu.png'

import config from '@/config'
import utils from '@/util'
import { menuList } from './menu'

export default {
  data () {
    return {
      logo,
      menuImg,
      geekbangServer: config.geekbangServer,
      menuList: [
        {
          name: '首页',
          link: config.geekbangServer
        },
        ...menuList
      ],
      isShowModal: false
    }
  },
  computed: {
    ...mapState(['loginUser'])
  },
  watch: {
    isShowModal (val) {
      if (val) {
        utils.fixedBody.open()
      } else {
        utils.fixedBody.close()
      }
    }
  },
  created () {
    this.menuList.forEach(item => {
      item.isActive = true
    })
  },
  destroyed () {

  },
  methods: {
    jump (item, index) {
      if (item.submenu) {
        this.$set(item, 'isActive', !item.isActive)
        this.$forceUpdate()
        this.setItemHeight(item, index)
        return
      }

      if (item.disabled) {
        return
      }

      this.isShowModal = false
      window.location.href = item.link
    },

    login () {
      login()
    },

    goAccount () {
      window.location.href = `${config.accountServer}/dashboard`
    },

    setItemHeight (item, idx) {
      this.$nextTick(() => {
        const height = this.$refs.submenuList[idx].offsetHeight
        this.$refs.submenuListWrapper[idx].style.height = item.isActive ? `${height}px` : '0px'
      })
    }
  }
}
</script>

<style lang="scss" module>
.shim {
  height: 52px;
}
.main {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 52px;
  padding: 0 8px 0 20px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(206,211,226,0.25);
}

.logoWrapper {
  height: 23px;

  .logo {
    height: 23px;
  }
}

.userInfo {
  display: flex;
  align-items: center;
}

.login {
  font-size: 14px;
  font-weight: 400;
  color: #404040;
}

.menuIcon {
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 52px;
}

// 下拉弹窗
.dropModal {
  position: fixed;
  z-index: 999;
  top: 52px;
  width: 100%;
}

.mask {
  height: 100vh;
  background: rgba(0,0,0,.5);
}

.modalContent {
  position: absolute;
  top: 0;
  width: 100%;
  height: 490px;
  background: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition: all .2s;
}

.menuList {
  padding-top: 18px;
}

.menuItemWrapper {
  padding: 0 20px;
}

.menuItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 15px 0;
  line-height: 15px;
  font-size: 16px;
  color: #404040;
  white-space: nowrap;
}

.arrowIcon {
  display: block;
  position: relative;
  top: 2px;
  margin-left: 3px;
  zoom: .5;
  opacity: .8;
  transition: all .3s;

  &.open {
    transform: rotate(180deg);
  }
}

.submenuListWrapper {
  overflow: hidden;
  transition: height .3s ease;
}

.submenuItem {
  position: relative;
  padding: 15px;
  font-size: 16px;
  color: #404040;

  &::after {
    content: '';
    position: absolute;
    top: 24px;
    left: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #888888;
  }

  &.disabled {
    color: #c9c9c9;
  }
}
</style>
